import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_adiantamento';
import apidesp from '../../services/api_despesas';
import styles from "./styles.module.css";
import { useParams } from "react-router-dom";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { FiAlignJustify, FiEdit } from "react-icons/fi";
import Swal from 'sweetalert2';


export default function Dashboards() {

    const [dashboards, setDashboards] = useState([]);
    const [atualizar, setAtualizar] = useState(true);
    const [isControladoria, setIsControladoria] = useState(false);
    const [modalRelatorioOpen, setModalRelatorioOpen] = useState(false);
    const [selectedRelatorio, setSelectedRelatorio] = useState({});
    const [modalUsuariosOpen, setModalUsuariosOpen] = useState(false);
    const [usuarios, setUsuarios] = useState([]);
    const [image, setImage] = useState('');
    const [html, setHtml] = useState('');
    const [salvando, setSalvando] = useState(false);
    const [checkAllUsuarios, setCheckAllUsuarios] = useState(false);
    const [publicUrl, setPublicUrl] = useState('');
    const [descricao, setDescricao] = useState('');

    const { id } = useParams();

    const hiddenFileInput = useRef(null);
    const hiddenFileInputHtml = useRef(null);

    useEffect(() => {
        api.get(`/dashboards/getusers`).then(function (response) {
            if (response.data) {
                setUsuarios(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);

    useEffect(() => {
        if (atualizar) {
            api.get(`/dashboards/categoria/${id}`).then(function (response) {
                if (response.data) {
                    setDashboards(response.data);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(false);
            });
        }
    }, [id, atualizar]);

    useEffect(() => {
        apidesp.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 5) {
                            setIsControladoria(true);
                            return;
                        }

                    })
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function handleEditarDashboard(relatorio) {
        setImage(relatorio.url);
        setHtml(relatorio.html);

        setSelectedRelatorio(relatorio);

        setDescricao(relatorio.descricao);
        setPublicUrl(relatorio.public_url);

        const objuser = Object.assign([], usuarios);

        relatorio.user_relatorios.map((usuario) => {
            var selected = usuarios.find(user => user.id === usuario.usuario_id);
            selected.checked = 1;
        });

        setUsuarios(objuser);

        setModalRelatorioOpen(true);

    }

    function renderEditar(relatorio) {
        if (isControladoria) {
            return (
                <FiEdit
                    size="20"
                    className={styles.btneditar}
                    onClick={() => handleEditarDashboard(relatorio)}
                />
            )
        }
    }

    function handleOpenRelatorio(id) {

        const win = window.open(`/dashboard/${id}`, "_blank");
        win.focus();
    }

    function renderDashboards() {

        return (
            dashboards.map((dashboard, index) => {
                return (
                    <div className={styles.contentitemrelatorio} key={index}>
                        <div className={styles.itemrelatorio} onClick={() => handleOpenRelatorio(dashboard.id)}>
                            <img src={dashboard.url} className={styles.imgrel}></img>
                            {dashboard.descricao}
                        </div>
                        {renderEditar(dashboard)}
                    </div>
                )
            })
        )
    }

    function handleClickNewRelatorio() {
        setSelectedRelatorio({});
        setImage('');
        setHtml('');
        setModalRelatorioOpen(true);
    }

    function renderNew() {
        if (isControladoria) {
            return (
                <div>
                    <BsFillPlusCircleFill
                        onClick={() => handleClickNewRelatorio()}
                        size="50"
                        color='green'
                        className={styles.newcategoria}
                    />

                </div>
            )
        } else {
            return (<></>)
        }
    }

    function fechaModalRelatorio() {
        setSelectedRelatorio({});
        setModalRelatorioOpen(false);
        const objuser = Object.assign([], usuarios);

        objuser.forEach((usuario) => {
            usuario.checked = 0;
        });

        setDescricao('');
        setPublicUrl('');
        setImage('');
        setHtml('');

        setUsuarios(objuser);
    }


    function renderImg() {
        if (image) {
            var file;
            if (typeof (image) === 'string') {
                file = image;
            } else {
                file = URL.createObjectURL(image);
            }
            return (
                <img src={file} className={styles.imgrelatorio} alt='Imagem do relatório'/>
            )
        } else {
            return (
                <>Clique para adicionar a imagem</>
            )
        }
    }

    function renderHtml() {
        if(selectedRelatorio.html && typeof html === 'string') {
            return (
                <>Clique para alterar a versão de painéis automáticos (Atual: {selectedRelatorio.html.slice(0, selectedRelatorio.html.lastIndexOf('.html ')+5)})</>
            )
        } if(html) {
            return (
                <>Clique para alterar a versão de painéis automáticos (Atual: {html.name})</>
            )
        } else {
            return (
                <>Clique para adicionar a versão de painéis automáticos</>
            )
        }
    }

    function handleSelectImg() {
        hiddenFileInput.current.click();
    }

    function handleSelectHtml() {
        hiddenFileInputHtml.current.click();
    }

    function renderRelatorio() {
        return (
            <>
                <div className={styles.contenteditar}>
                    <div className={styles.columns}>
                        <label>DESCRIÇÃO</label>
                        <input type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
                    </div>
                    <div className={styles.columns}>
                        <label>URL PUBLICA</label>
                        <input type="text" value={publicUrl} onChange={(e) => setPublicUrl(e.target.value)} />
                    </div>
                    {/* <div className={styles.columns}>
                        <label>NOME</label>
                        <input type="text" value={(selectedRelatorio.name ? selectedRelatorio.name : '')} readOnly />
                    </div>
                    <div className={styles.columns}>
                        <label>ID</label>
                        <input type="text" value={(selectedRelatorio.id ? selectedRelatorio.id : '')} readOnly />
                    </div>
                    <div className={styles.columns}>
                        <label>DATASET</label>
                        <input type="text" value={(selectedRelatorio.datasetId ? selectedRelatorio.datasetId : '')} readOnly />
                    </div>
                    <div className={styles.columns}>
                        <label>URL</label>
                        <input type="text" value={(selectedRelatorio.embedUrl ? selectedRelatorio.embedUrl : '')} readOnly />
                    </div> */}
                </div>
                <div className={styles.columnimage}>
                    <div className={styles.divimg} onClick={() => handleSelectImg()}>
                        {renderImg()}
                        <input
                            type="file"
                            ref={hiddenFileInput}
                            accept="image/*," name="imagem" onChange={(e) => setImage(e.target.files[0])}
                            style={{ display: 'none' }}
                        />
                    </div>
                </div>
                <div className={styles.columnimage}>
                    <div className={styles.divimg} onClick={() => handleSelectHtml()}>
                        {renderHtml()}
                        <input
                            type="file"
                            ref={hiddenFileInputHtml}
                            accept=".html" name="html" onChange={(e) => setHtml(e.target.files[0])}
                            style={{ display: 'none' }}
                        />
                    </div>
                </div>
            </>
        )
    }

    function handleOpenModalUsuario() {
        setModalUsuariosOpen(true);
    }

    function fechaModalUsuarios() {
        setModalUsuariosOpen(false);
    }

    function handleStore() {

        if (!salvando) {


            var selectedusers = [];

            usuarios.map((usuario) => {
                if (usuario.checked) {
                    selectedusers.push(usuario);
                }
            })

            if (selectedusers.length < 1) {
                Swal.fire('NÃO HÁ USUÁRIOS SELECIONADOS!')
                return;
            }

            if (descricao === '') {
                Swal.fire("A DESCRIÇÃO NÃO PODE FICAR EM BRANCO");
                return;
            }

            if (publicUrl === '' && !html) {
                Swal.fire("A URL PÚBLICA OU O ARQUIVOS DOS PAINÉIS AUTOMÁTICOS DEVE SER PREENCHIDO");
                return;
            }

            if (!image || image === '') {
                Swal.fire("A IMAGEM NÃO PODE FICAR EM BRANCO");
                return;
            }

            if(html && typeof (html) !== 'string' && html.name.slice(html.name.lastIndexOf('.')+1) !== 'html') {
                Swal.fire("SOMENTE ARQUIVOS HTML SÃO ACEITOS PARA OS PAINÉIS AUTOMÁTICOS");
                return;
            }

            setSalvando(true);

            let anexo = new FormData();

            if (typeof (image) !== 'string') {
                anexo.append('file', image);
            }

            if (typeof (html) !== 'string') {
                anexo.append('htmlFile', html);
            }

            anexo.append('relatorio', JSON.stringify({ descricao: descricao, public_url: publicUrl }));
            anexo.append('usuarios', JSON.stringify(selectedusers));
            anexo.append('categoria', id);

            if (selectedRelatorio.id) {
                anexo.append('id', selectedRelatorio.id);
                api.put('/dashboards/relatorio', anexo).then(function (response) {
                    if (response.data) {
                        fechaModalRelatorio();
                        setAtualizar(true);
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            } else {
                api.post('/dashboards/relatorio', anexo).then(function (response) {
                    if (response.data) {
                        fechaModalRelatorio();
                        setAtualizar(true);
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            }
        }

    }


    function renderModalRelatorio() {
        return (
            <div
                className={(modalRelatorioOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalRelatorio()}
                ><b>x</b></span>
                <div>
                    <h3><b>CADASTRAR NOVO RELATÓRIO</b></h3>

                </div>
                {/* {renderLinkRel()} */}
                {renderRelatorio()}
                <div className={styles.botoes}>
                    <div className={styles.botao}>
                        <input type="button" value="ATRIBUIR USUÁRIOS" className='btn-primary' onClick={() => handleOpenModalUsuario()} />
                    </div>
                    <div className={styles.botao}>
                        <input type="button" value="SALVAR"
                            onClick={() => handleStore()} className="btn btn-primary"
                        />
                    </div>
                </div>
            </div>
        )
    }

    function handleCheckUsuario(usuario, checked) {
        var objuser = Object.assign([], usuarios);
        var selecteduser = objuser.find(u => u.id === usuario.id);
        selecteduser.checked = checked;
        setUsuarios(objuser)
    }

    function renderCheckUsuario(usuario) {
        if (usuario.checked) {
            return (
                <input type="checkbox" onClick={() => handleCheckUsuario(usuario, 0)} checked />
            )
        } else {
            return (
                <input type="checkbox" onClick={() => handleCheckUsuario(usuario, 1)} />
            )
        }

    }

    function renderUsuarios() {
        return (
            usuarios.map((usuario, index) => {
                return (
                    <div className={styles.contentusuario} key={index}>
                        {renderCheckUsuario(usuario)}
                        <div className={styles.usuario}>
                            {usuario.usuario}
                        </div>
                    </div>
                )
            })
        )
    }

    function handleCheckAllUsuario(check) {

        if (check) {
            setCheckAllUsuarios(true);
            var objUsuarios = Object.assign([], usuarios);
            objUsuarios.forEach((usuario) => {
                usuario.checked = true;
            })
        } else {
            setCheckAllUsuarios(false);
            var objUsuarios = Object.assign([], usuarios);
            objUsuarios.forEach((usuario) => {
                usuario.checked = false;
            })
        }
    }

    function renderCheckAllUsuarios() {
        if (checkAllUsuarios) {
            return (
                <input type="checkbox" onClick={() => handleCheckAllUsuario(0)} checked />
            )
        } else {
            return (
                <input type="checkbox" onClick={() => handleCheckAllUsuario(1)} />
            )
        }
    }

    function renderModalUsuarios() {
        return (
            <div
                className={(modalUsuariosOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalUsuarios()}
                ><b>x</b></span>
                <div>
                    <h3>{renderCheckAllUsuarios()}<b>USUÁRIOS</b></h3>
                </div>
                <div className={styles.gridusuarios}>
                    {renderUsuarios()}
                </div>
            </div>
        )
    }

    return (
        <>
            {renderModalRelatorio()}
            {renderModalUsuarios()}
            <div className="container-lg">
                <Header title="DASHBOARDS" />
                {renderNew()}
                <div className={styles.contentdashboards}>
                    {renderDashboards()}
                </div>
            </div>
        </>
    )
}